import { useEffect } from 'react';

const CHECK_INTERVAL = 5 * 60 * 1000;

export const VersionChecker = () => {
    const checkVersion = async () => {
        try {
            const response = await fetch('/version.json?t=' + Date.now(), {
                cache: 'no-cache',
            });

            if (!response.ok) {
                console.warn('Unable to check version');
                return;
            }

            const data = await response.json();
            const newVersion = data.version;

            const storedVersion = localStorage.getItem('app_version');

            if (!storedVersion) {
                localStorage.setItem('app_version', newVersion);
                return;
            }

            if (storedVersion !== newVersion) {
                console.info('New version detected, reloading...');
                localStorage.setItem('app_version', newVersion);
                window.location.reload();
            }
        } catch (error) {
            console.error('Error checking version:', error);
        }
    };

    useEffect(() => {
        (async () => {
            await checkVersion();
        })();
        const interval = setInterval(checkVersion, CHECK_INTERVAL);

        return () => clearInterval(interval);
    }, []);

    return null;
};
